module.exports = __webpack_public_path__ + "img/组 40@2x (2).6da5ca65.png";